export default {
  'title': 'Save for Tomorrow - Live for Today | Stackr',
  'tool': {
    'inv_choices': {
      'heading': 'Investment Choices',
      'tab_heading': 'Choices',
      'conservative': 'Conservative',
      'balanced': 'Balanced',
      'unconstrained': 'Unconstrained',
      'digital': 'Digital',
      'capital': 'Capital'
    },
    'inv_amount': {
      'heading': 'Investment Amount',
      'tab_heading': 'Amount',
      'lump_sum': 'Lump Sum',
      'monthly_payment': 'Monthly payment'
    },
    'inv_timeframe': {
      'heading': 'Timeframe',
      'tab_heading': 'Timeframe',
      'years': 'Years',
      'instructions': 'Select your timeframe by sliding left or right'
    },
    'results': {
      'high': 'High',
      'medium': 'Medium',
      'low': 'Low',
      'blend': 'Blend',
      'digital': 'Digital',
      'capital': 'Capital',
      'x_axis_label': 'Timeframe',
      'y_axis_label': 'Amount in US $'
    },
    'summary' : {
      'view_button_text': 'View Summary',
      'heading': 'Investment Summary',
      'back_button_text': 'Back',
      'done_button_text': 'Done',
      'duration_years': 'In {{duration}} Years'
    }
  },
  'next_steps': {
    'heading': 'Stackr next steps',
    'back_button_text': 'Back to Simulator',
    'intro': {
      'heading': 'Intro',
      'body': 'We\'re currently working hard on the next stages of development of the tool which would take you through the process of investing.'
    },
    'application_form': {
      'heading': 'Application Form',
      'body': 'You will complete a fully digital step-by-step KYC/AML and application form.'
    },
    'payment': {
      'heading': 'Payment',
      'body': 'Having received an email from the administrator, clients will then be able to transfer funds to their Stackr Trust Account.'
    },
    'dashboard': {
      'heading': 'Dashboard',
      'body': 'Once invested, clients can view their personal accounts in their dashboard.'
    },
    'signup_form': {
      'heading': 'Sign Up',
      'instructions': 'Enter your details to keep up to date.',
      'name_label': 'Name',
      'email_label': 'Email',
      'name_placeholder': 'John Doe',
      'email_placeholder': 'email@example.com',
      'submit_button_text': 'Sign Up',
      'thanks_heading': 'Thanks for signing up',
      'thanks_sub_heading': 'You will now receive Stackr news and updates.',
      'thanks_done_button_text': 'Done'
    }
  },
  'disclaimer': 'Disclaimer'
};